import { type LinkProps, Link as RRLink } from 'react-router-dom';
import z from 'z';
export default function Link({ to, ...other }: LinkProps) {
  return <RRLink to={z.format(to)} {...other} />;
}
